// Which uploads are 3D models. Deliberately its own module: the case screen needs this predicate to
// decide whether to offer a "view in 3D" button, and importing it from the viewer dragged all of
// three.js into the main bundle — 600 KB every user downloaded to answer a question about a
// filename.
export const MODEL_EXT = new Set(['stl', 'ply', 'obj']);
export const modelExt = (name: string): string => (name.split('.').pop() ?? '').toLowerCase();
export const isModelFile = (name: string): boolean => MODEL_EXT.has(modelExt(name));
